module.exports = __webpack_public_path__ + "a70574fc869c1ab633d245d8ad2a69db.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/hairbrush-s.png
// module id = 2660
// module chunks = 0